<div id="scroll-container">
    <div id="scroll-text">
      <span class="me-5">Slow internet detected!</span>
      <span class="mx-5">Slow internet detected!</span>
      <span class="mx-5">Slow internet detected!</span>
      <span class="mx-5">Slow internet detected!</span>
      <span class="ms-5">Slow internet detected!</span>
    </div>
  </div>